import { ToDo } from "@/types";
import api from "@/config/axiosConfig";

export const addTodo = async (
  tripId: string,
  text: string
): Promise<{ id: number }> => {
  const response = await api.trips.post(`/${tripId}/todos`, { text });
  return response.data;
};

export const toggleTodoComplete = async (
  tripId: string,
  todoId: number
): Promise<ToDo> => {
  const response = await api.trips.patch(`/${tripId}/todos/${todoId}/toggle`);
  return response.data;
};

export const deleteTodo = async (
  tripId: string,
  todoId: number
): Promise<void> => {
  await api.trips.delete(`/${tripId}/todos/${todoId}`);
};
